import { Collapse, Button } from '@mui/material';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DateTimePicker } from '@mui/x-date-pickers';
import Container from './styles/Container';
import ButtonWrapper from './styles/ButtonWrapper';
import { DEFAULT_FILTERS, priorities, statuses } from '../constants/filters';
import ActionBarDateTimePicker from '../../../../shared/ui/ActionBarDateTimePicker/ActionBarDateTimePicker';
import MultipleSelect from '../../../../shared/ui/MultipleSelect';
import InputDate from './styles/InputDate';
import SelectWrapper from './styles/SelectWrapper';
import DateWrapper from './styles/DateWrapper';

function AdvicesFiltersWidget({ filters, setFilters, setPage, isOpen }) {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleResetFilters = () => {
    setLocalFilters(DEFAULT_FILTERS);
  };

  const handleFilter = () => {
    setFilters(localFilters);
    setPage(0);
  };

  const changeSelect = (event) => {
    setLocalFilters((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  return (
    <Collapse in={isOpen}>
      <Container>
        <DateWrapper>
          <DateTimePicker
            label="Дата создания после"
            value={localFilters.createdDate}
            onChange={(newDate) => {
              setLocalFilters((prev) => ({ ...prev, createdDate: newDate }));
            }}
            inputProps={{
              placeholder: 'дд.мм.гггг чч:мм',
            }}
            renderInput={(params) => <InputDate size="small" fullWidth {...params} />}
            components={{
              ActionBar: ActionBarDateTimePicker,
            }}
          />
        </DateWrapper>
        <DateWrapper>
          <DateTimePicker
            label="Дата окончания до"
            value={localFilters.endTime}
            onChange={(newDate) => {
              setLocalFilters((prev) => ({ ...prev, endTime: newDate }));
            }}
            inputProps={{
              placeholder: 'дд.мм.гггг чч:мм',
            }}
            renderInput={(params) => <InputDate size="small" fullWidth {...params} />}
            components={{
              ActionBar: ActionBarDateTimePicker,
            }}
          />
        </DateWrapper>
        <SelectWrapper>
          <MultipleSelect
            label="Приоритеты"
            name="priorities"
            items={priorities}
            value={localFilters.priorities}
            onChange={changeSelect}
          />
        </SelectWrapper>
        <SelectWrapper>
          <MultipleSelect
            label="Статусы"
            name="statuses"
            items={statuses}
            value={localFilters.statuses}
            onChange={changeSelect}
          />
        </SelectWrapper>
      </Container>

      <ButtonWrapper>
        <Button onClick={handleResetFilters} variant="text">
          Сбросить
        </Button>
        <Button onClick={() => handleFilter(filters)} variant="contained">
          Поиск
        </Button>
      </ButtonWrapper>
    </Collapse>
  );
}

AdvicesFiltersWidget.propTypes = {
  filters: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  setFilters: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default AdvicesFiltersWidget;
